module.exports = __webpack_public_path__ + "media/images/icons/outlined/share-alt-def95252c819969feaa2963e5566f730.svg";